import * as React from 'react';
import { useHistory } from 'react-router';
import axios from 'axios';
import PageContent from '../../components/layout/PageContent';
import CustomForm from '../../components/form/CustomForm';
import { handleFormImageUpload } from '../../utils';
import { enums, enumDictionary } from './helper';

const AddCountry = () => {

	const [ fields, setFields ] = React.useState([]);

	const history = useHistory();

	React.useEffect(() => {
		axios.get(`/api/country`)
		.then(({ data = {} }) => {
			const { result = [] } = data;

			const formattedFields = result.map(field => {

				if (field.key === 'logo') {
					return {
						...field,
						instance: 'string',
						enum: enums,
						enumDictionary,
					}
				}

				return {
					...field,
				}
			})

			setFields(formattedFields);
		})
		.catch(err => {
			console.log(err);
		})
	}, []);

	const handleSubmit = values => {
		axios.post(`/api/country`, values)
		.then(({ data }) => {
			if (data.statusCode === 200) {
				history.push('/country');
			}
		})
		.catch(err => {
			console.log(err);
		})
	}

	const handleCancel = () => {
		history.push('/country')
	}

	return (
		<PageContent 
			background='#fff'
			subheader={{
				title: 'Улс үүсгэх',
				background: '#ffffff'
			}}
		>
			<CustomForm
				fields={fields}
				onSubmit={handleSubmit}
				onCancel={handleCancel}
				imageUpload={handleFormImageUpload}
			/>
		</PageContent>
	)
}

export default AddCountry;